import { PageTypes } from 'utils/chat/instructorHugoContext';

const PAGE_CONFIG = {
    [PageTypes.COURSE_DASHBOARD]: { key: 'pages.dashboard', default: 'Course Dashboard' },
    [PageTypes.ASSIGNMENTS]: { key: 'pages.assignments', default: 'Assignments' },
    [PageTypes.ASSIGNMENT_CREATE]: { key: 'pages.assignment_create', default: 'Create Assignment' },
    [PageTypes.ASSIGNMENT_OVERVIEW]: { key: 'pages.assignment_overview', default: 'Assignment Overview' },
    [PageTypes.ASSIGNMENT_EDIT]: { key: 'pages.assignment_edit', default: 'Assignment Edit' },
    [PageTypes.GRADING]: { key: 'pages.grading', default: 'Grading' },
    [PageTypes.ASSIGNMENT_PREVIEW]: { key: 'pages.assignment_preview', default: 'Assignment Preview' },
    [PageTypes.SUBMISSIONS]: { key: 'pages.submissions', default: 'Submissions' },
    [PageTypes.SUBMISSION_DETAIL]: { key: 'pages.submission_detail', default: 'Submission Detail' },
    [PageTypes.PEOPLE]: { key: 'pages.people', default: 'People' },
    [PageTypes.COURSE_SETTINGS]: { key: 'pages.course_settings', default: 'Course Settings' },
    [PageTypes.RUBRICS]: { key: 'pages.rubrics', default: 'Rubrics' },
    [PageTypes.UNKNOWN]: { key: 'pages.general', default: 'General' },
};

const PAGE_SUGGESTIONS = {
    [PageTypes.COURSE_DASHBOARD]: [
        { key: 'hugo-chat.suggestions.dashboard-progress', default: 'What should I check first in this course?' },
        { key: 'hugo-chat.suggestions.dashboard-next', default: 'Help me find assignments that need attention.' },
        { key: 'hugo-chat.suggestions.dashboard-summary', default: 'Summarize what is happening in this course.' },
    ],
    [PageTypes.ASSIGNMENTS]: [
        { key: 'hugo-chat.suggestions.assignments-review', default: 'Which assignments should I review first?' },
        { key: 'hugo-chat.suggestions.assignments-improve', default: 'Help me improve an assignment setup.' },
        { key: 'hugo-chat.suggestions.assignments-next', default: 'What should I do before publishing an assignment?' },
    ],
    [PageTypes.ASSIGNMENT_CREATE]: [
        { key: 'hugo-chat.suggestions.create-outline', default: 'Help me outline this assignment.' },
        { key: 'hugo-chat.suggestions.create-rubric', default: 'Suggest rubric criteria for this assignment.' },
        { key: 'hugo-chat.suggestions.create-instructions', default: 'Review my assignment instructions for clarity.' },
    ],
    [PageTypes.ASSIGNMENT_OVERVIEW]: [
        { key: 'hugo-chat.suggestions.overview-review', default: 'What can you help me with here?' },
        { key: 'hugo-chat.suggestions.overview-status', default: 'Help me review this assignment status.' },
        { key: 'hugo-chat.suggestions.overview-next', default: 'What should I check next for this assignment?' },
    ],
    [PageTypes.ASSIGNMENT_EDIT]: [
        { key: 'hugo-chat.suggestions.setup-review', default: 'Review this assignment setup.' },
        { key: 'hugo-chat.suggestions.setup-rubric', default: 'Help me align the rubric with the instructions.' },
        { key: 'hugo-chat.suggestions.setup-feedback', default: 'Suggest feedback settings for this assignment.' },
    ],
    [PageTypes.GRADING]: [
        { key: 'hugo-chat.suggestions.grading-consistency', default: 'Help me grade this consistently.' },
        { key: 'hugo-chat.suggestions.grading-rubric', default: 'Explain how to apply this rubric.' },
        { key: 'hugo-chat.suggestions.grading-feedback', default: 'Help me write clearer feedback.' },
    ],
    [PageTypes.ASSIGNMENT_PREVIEW]: [
        { key: 'hugo-chat.suggestions.preview-check', default: 'What should I check in this preview?' },
        { key: 'hugo-chat.suggestions.preview-student', default: 'Does this look clear from a student perspective?' },
        { key: 'hugo-chat.suggestions.preview-improve', default: 'Suggest improvements before I publish.' },
    ],
    [PageTypes.SUBMISSIONS]: [
        { key: 'hugo-chat.suggestions.submissions-prioritize', default: 'Help me prioritize these submissions.' },
        { key: 'hugo-chat.suggestions.submissions-progress', default: 'Summarize submission progress.' },
        { key: 'hugo-chat.suggestions.submissions-patterns', default: 'What patterns should I look for while reviewing?' },
    ],
    [PageTypes.SUBMISSION_DETAIL]: [
        { key: 'hugo-chat.suggestions.submission-detail-review', default: 'Help me review this submission.' },
        { key: 'hugo-chat.suggestions.submission-detail-grade', default: 'Explain this grade.' },
        { key: 'hugo-chat.suggestions.submission-detail-feedback', default: 'Help me improve this feedback.' },
    ],
    [PageTypes.PEOPLE]: [
        { key: 'hugo-chat.suggestions.people-progress', default: 'Help me understand student progress.' },
        { key: 'hugo-chat.suggestions.people-support', default: 'Which students may need support?' },
        { key: 'hugo-chat.suggestions.people-roster', default: 'Help me review this course roster.' },
    ],
    [PageTypes.COURSE_SETTINGS]: [
        { key: 'hugo-chat.suggestions.settings-check', default: 'What settings should I review?' },
        { key: 'hugo-chat.suggestions.settings-lms', default: 'Help me check LMS connection settings.' },
        { key: 'hugo-chat.suggestions.settings-course', default: 'Explain what these course settings do.' },
    ],
    [PageTypes.RUBRICS]: [
        { key: 'hugo-chat.suggestions.rubrics-review', default: 'Review this rubric for clarity.' },
        { key: 'hugo-chat.suggestions.rubrics-criteria', default: 'Suggest stronger rubric criteria.' },
        { key: 'hugo-chat.suggestions.rubrics-levels', default: 'Help me make performance levels more specific.' },
    ],
    [PageTypes.UNKNOWN]: [
        { key: 'hugo-chat.suggestions.general-help', default: 'What can you help me with here?' },
        { key: 'hugo-chat.suggestions.general-next', default: 'Suggest a next step for this page.' },
        { key: 'hugo-chat.suggestions.general-explain', default: 'Explain what I can do on this page.' },
    ],
};

export const getPageLabel = (pageType, t) => {
    const config = PAGE_CONFIG[pageType] || PAGE_CONFIG[PageTypes.UNKNOWN];
    return t(config.key, config.default);
};

export const getPageSuggestions = (pageType, t) => {
    const suggestions = PAGE_SUGGESTIONS[pageType] || PAGE_SUGGESTIONS[PageTypes.UNKNOWN];
    return suggestions.map((suggestion) => ({
        text: t(suggestion.key, suggestion.default),
    }));
};
